import styles from './about-tech.module.css';
import { techIcons } from 'img';

function AboutTech() {
  return (
    <section id="sobre-nosotros" className={styles['about-tech']}>
      <div className={styles['about-container']}>
        <h1 className={styles['about-h1']}>Sobre Nosotros</h1>
        <p className={styles['about-text']}>
          Somos una startup de desarrollo de software. <br />
          Hacemos realidad las buenas ideas.
          <br />
          <span>
            <a style={{ fontSize: '25px', color: 'rgb(168 0 172 / 66%)' }} href="/about">Ver más</a>
          </span>
        </p>
      </div>
      <div id="tecnologias" className={styles['tech-container']}>
        <h1 className={styles['tech-h1']}>Tecnologías</h1>
        <div className={styles['tech-icons']}>
         <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[5]} alt="angular-icon" />
            <p className={styles['text']}>Angular</p>
          </div>
         <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[10]} alt="nestjs-icon" />
            <p className={styles['text']}>NestJS</p>
          </div>
          <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[2]} alt="nodejs-icon" />
            <p className={styles['text']}>NodeJS</p>
          </div>
          <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[3]} alt="electron-icon" />
            <p className={styles['text']}>Electron</p>
          </div>
          <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[4]} alt="mongodb-icon" />
            <p className={styles['text']}>MongoDB</p>
          </div>

          <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[0]} alt="react-icon" />
            <p className={styles['text']}>React</p>
          </div>
          <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[1]} alt="flutter-icon" />
            <p className={styles['text']}>Flutter</p>
          </div>
          <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[6]} alt="git-icon" />
            <p className={styles['text']}>Git</p>
          </div>
          <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[7]} alt="mysql-icon" />
            <p className={styles['text']}>MySQL</p>
          </div>
          <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[8]} alt="bootstrap-icon" />
            <p className={styles['text']}>Bootstrap</p>
          </div>
          <div className={styles['icon-cont']}>
            <img className={styles['icon']} src={techIcons[9]} alt="firebase-icon" />
            <p className={styles['text']}>Firebase</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutTech;
